export default {
    user: null,
    product_card: null,
    messages_chat: null,
    badge: {
        orders: 0,
        activations: 0,
        messages: 0,
        orders_distributors: 0
    },
    categories: [],
    brands: [],
    features: [],
    values: [],
    classes: [],
    resources: [],
    categorySelect: [],
    resource: null,
    isLogin: false,
    change: false,
    pageSet: 1,
    searchSet: '',
    language: (localStorage.getItem('language')) ? localStorage.getItem('language') : 'ru',
    brand: [],
    role: [],
    menu: [],
}